import type { FilterSection } from '@/types/filters';

/** Static filter sections rendered by the discover/echoes filter popup. */
export const FILTER_SECTIONS: FilterSection[] = [
  {
    id: 'category',
    title: 'Category',
    options: [
      { id: 'Sports', label: 'Sports' },
      { id: 'Entertainment', label: 'Entertainment' },
      { id: 'Science', label: 'Science' },
      { id: 'Philosophy', label: 'Philosophy' },
      { id: 'Politics', label: 'Politics' },
      { id: 'Business', label: 'Business' },
      { id: 'Exploration', label: 'Exploration' },
    ],
  },
  {
    id: 'rating',
    title: 'Rating',
    options: [
      { id: '0-1k', label: '< 1k', hasStar: true },
      { id: '1k-10k', label: '1k–10k', hasStar: true },
      { id: '10k-100k', label: '10k–100k', hasStar: true },
      { id: '100k+', label: '100k+', hasStar: true },
    ],
  },
  {
    id: 'popularity',
    title: 'Popularity',
    options: [
      { id: 'trending', label: 'Trending' },
      { id: 'most_popular', label: 'Most Popular' },
      { id: 'new_echoes', label: 'New Echoes' },
    ],
  },
];
